// extracted by mini-css-extract-plugin
module.exports = {"containerstrip":"subheader-module--containerstrip--3bw3w","buttonColor":"subheader-module--buttonColor--14yJ7","buttonColorBold":"subheader-module--buttonColorBold--1jU_N"};